<template>
  <b-field
    :label="label"
    :class="{ 'obligatoire': obligatoire }">
    <b-select
      v-model="itemId"
      :disabled="disabled"
      :placeholder="placeholder"
      expanded>
      <option v-if="!obligatoire" :value="null"></option>
      <option
        v-for="item in filteredSecteur"
        :key="item.id"
        :value="item.id">
        {{ item.libelle }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');
const Secteur = createNamespacedHelpers('secteur');
const User = createNamespacedHelpers('user');

export default {
  name: 'secteur-input-selected',
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    obligatoire: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      secteursUtilisateur: [],
      filteredSecteur: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Secteur.mapGetters({
      secteurs: 'items',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    itemId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Secteur.mapActions({
      loadSecteurs: 'loadSecteurs',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.secteur]);
      await this.loadSecteurs({});
      this.secteursUtilisateur = cloneDeep(this.secteurs)
        ?.filter((item) => item.type === this.type)
        ?.filter(secteur => {
          if (this.utilisateur.secteursId) {
            return this.utilisateur.secteursId.some(sId => secteur.id === sId);
          }
          return false;
        });
      this.filteredSecteur = cloneDeep(this.secteurs)
        .filter((item) => (this.secteursUtilisateur.length > 0
          ? this.secteursUtilisateur.find(secteur => secteur.id === item.id)
          : true))
        .filter((item) => item.type === this.type)
        .filter((item) => item.actif);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
